import {
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAIL,
  DELETE_USER_SUCCESS,
  ADD_NEW_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  GET_USER_DETAIL,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_PHOTO,
  UPDATE_USER_PHOTO_SUCCESS,
  UPDATE_USER_PHOTO_FAIL,
  RESET_USER_SUCCESS,
  RESET_USER,
  GET_USER_AVAILABILITY,
  GET_USER_AVAILABILITY_SUCCESS,
  GET_USER_AVAILABILITY_FAIL,
  ADD_USER_AVAILABILITY,
  ADD_USER_AVAILABILITY_SUCCESS,
  ADD_USER_AVAILABILITY_FAIL,
  GET_USER_PROFILE,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAIL,
  ADD_USER_PROFILE,
  ADD_USER_PROFILE_SUCCESS,
  ADD_USER_PROFILE_FAIL,
  GET_HOUR_TYPES,
  GET_HOUR_TYPES_SUCCESS,
  GET_HOUR_TYPES_FAIL,
  GET_GENDERS,
  GET_GENDERS_SUCCESS,
  GET_GENDERS_FAIL,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  UPDATE_IMPERSONATE_USER,
  UPDATE_IMPERSONATE_USER_FAIL,
  UPDATE_IMPERSONATE_USER_SUCCESS,
  DELETE_IMPERSONATE_USER,
  DELETE_IMPERSONATE_USER_FAIL,
  DELETE_IMPERSONATE_USER_SUCCESS,
  RESET_USER_PASSWORD,
  RESET_USER_PASSWORD_SUCCESS,
  RESET_USER_PASSWORD_FAIL,
} from "./actionTypes"

export const getUsers = () => ({
  type: GET_USERS,
})

export const getUsersSuccess = users => ({
  type: GET_USERS_SUCCESS,
  payload: users,
})

export const getUsersFail = error => ({
  type: GET_USERS_FAIL,
  payload: error,
})

export const deleteUser = user => ({
  type: DELETE_USER,
  payload: user,
})

export const deleteUserSuccess = user => ({
  type: DELETE_USER_SUCCESS,
  payload: user,
})

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
})

export const addNewUser = user => ({
  type: ADD_NEW_USER,
  payload: user,
})

export const addUserSuccess = user => ({
  type: ADD_USER_SUCCESS,
  payload: user,
})

export const addUserFail = error => ({
  type: ADD_USER_FAIL,
  payload: error,
})

export const getUserDetail = userId => ({
  type: GET_USER_DETAIL,
  userId,
})

export const getUserDetailSuccess = user => ({
  type: GET_USER_DETAIL_SUCCESS,
  payload: user,
})

export const getUserDetailFail = error => ({
  type: GET_USER_DETAIL_FAIL,
  payload: error,
})

export const updateUser = user => ({
  type: UPDATE_USER,
  payload: user,
})

export const updateUserSuccess = user => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
})

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})

export const updateUserPhoto = user => ({
  type: UPDATE_USER_PHOTO,
  payload: user,
})
export const updateUserPhotoSuccess = user => ({
  type: UPDATE_USER_PHOTO_SUCCESS,
  payload: user,
})

export const updateUserPhotoFail = error => ({
  type: UPDATE_USER_PHOTO_FAIL,
  payload: error,
})

export const resetUser = () => ({
  type: RESET_USER,
})

export const resetUserSuccess = user => ({
  type: RESET_USER_SUCCESS,
  payload: user,
})

export const getUserAvailability = userID => ({
  type: GET_USER_AVAILABILITY,
  userID,
})

export const getUserAvailabilitySuccess = useravailability => ({
  type: GET_USER_AVAILABILITY_SUCCESS,
  payload: useravailability,
})

export const getUserAvailabilityFail = error => ({
  type: GET_USER_AVAILABILITY_FAIL,
  payload: error,
})

export const addUserAvailability = (userID, useravailability) => ({
  type: ADD_USER_AVAILABILITY,
  payload: { userID, useravailability },
})

export const addUserAvailabilitySuccess = useravailability => ({
  type: ADD_USER_AVAILABILITY_SUCCESS,
  payload: useravailability,
})

export const addUserAvailabilityFail = error => ({
  type: ADD_USER_AVAILABILITY_FAIL,
  payload: error,
})

export const getUserProfile = userId => ({
  type: GET_USER_PROFILE,
  userId,
})

export const getUserProfileSuccess = userprofile => ({
  type: GET_USER_PROFILE_SUCCESS,
  payload: userprofile,
})

export const getUserProfileFail = error => ({
  type: GET_USER_PROFILE_FAIL,
  payload: error,
})

export const addUserProfile = (userId, userprofile) => ({
  type: ADD_USER_PROFILE,
  payload: { userId, userprofile },
})

export const addUserProfileSuccess = userprofile => ({
  type: ADD_USER_PROFILE_SUCCESS,
  payload: userprofile,
})
export const addUserProfileFail = error => ({
  type: ADD_USER_PROFILE_FAIL,
  payload: error,
})

export const getHourTypes = () => ({
  type: GET_HOUR_TYPES,
})

export const getHourTypesSuccess = hourTypes => ({
  type: GET_HOUR_TYPES_SUCCESS,
  payload: hourTypes,
})

export const getHourTypesFail = error => ({
  type: GET_HOUR_TYPES_FAIL,
  payload: error,
})

export const getGenders = () => ({
  type: GET_GENDERS,
})

export const getGendersSuccess = genders => ({
  type: GET_GENDERS_SUCCESS,
  payload: genders,
})

export const getGendersFail = error => ({
  type: GET_GENDERS_FAIL,
  payload: error,
})

export const getProfile = rowID => ({
  type: GET_PROFILE,
  payload: rowID,
})

export const getProfileSuccess = profile => ({
  type: GET_PROFILE_SUCCESS,
  payload: profile,
})

export const getProfileFail = error => ({
  type: GET_PROFILE_FAIL,
  payload: error,
})

export const updateImpersonateUser = userID => ({
  type: UPDATE_IMPERSONATE_USER,
  payload: userID,
})

export const updateImpersonateUserSuccess = userprofile => ({
  type: UPDATE_IMPERSONATE_USER_SUCCESS,
  payload: userprofile,
})

export const updateImpersonateUserFail = error => ({
  type: UPDATE_IMPERSONATE_USER_FAIL,
  payload: error,
})

export const deleteImpersonateUser = userID => ({
  type: DELETE_IMPERSONATE_USER,
  payload: userID,
})

export const deleteImpersonateUserSuccess = userprofile => ({
  type: DELETE_IMPERSONATE_USER_SUCCESS,
  payload: userprofile,
})

export const deleteImpersonateUserFail = error => ({
  type: DELETE_IMPERSONATE_USER_FAIL,
  payload: error,
})

export const resetUserPassword = email => ({
  type: RESET_USER_PASSWORD,
  payload: email,
})

export const resetUserPasswordSuccess = email => ({
  type: RESET_USER_PASSWORD_SUCCESS,
  payload: email,
})

export const resetUserPasswordFail = error => ({
  type: RESET_USER_PASSWORD_FAIL,
  payload: error,
})
